import { Injectable } from '@angular/core';
import 'rxjs/Rx';
import { HttpClient, HttpHeaders } from '@angular/common/http';



@Injectable()
export class UsuariosService {

  usuarios:any[]=[];
  listaUsuarios=[];

  USnombre;
  USemail;
  UStelefono;
  USperfil;
  USactivo;
  USfechaultimoacceso;

  listaPerfilesUsuario=[];

  constructor(private http:HttpClient) { }

  getUsuarios( filtro, pagina, ordenacion ){
    filtro.nombre==""?this.USnombre="-":this.USnombre=filtro.nombre;
    filtro.email==""?this.USemail="-":this.USemail=filtro.email;
    filtro.telefono==""?this.UStelefono="-":this.UStelefono=filtro.telefono;
    filtro.perfil==""?this.USperfil="-":this.USperfil=filtro.perfil;
    filtro.activo==true?this.USactivo=1:this.USactivo=0;
    filtro.ultimoacceso==""?this.USfechaultimoacceso="-":this.USfechaultimoacceso=filtro.ultimoacceso;

    return this.http.get( `https://app.solucionlegal.es/API/index.php/Usuarios/usuarios/${this.USnombre}/${this.USemail}/${this.UStelefono}/${this.USperfil}/${this.USactivo}/${this.USfechaultimoacceso}/${pagina}/${ordenacion.campo}/${ordenacion.orden}` )
        .map(resp=>{
          this.usuarios=resp["usuarios"];
          
          return resp;
        });
  }

  getNombresUsuarios(){
    return this.http.get( `https://app.solucionlegal.es/API/index.php/Usuarios/nombresusuarios` )
    .map(resp=>{
      if(resp["err"]==false){
        this.listaUsuarios=resp["usuarios"];
        
        return true;
      }else{
        
        return false;
      }
    });
  }

  getNombresUsuariosCliente(codcliente){
    return this.http.get( `https://app.solucionlegal.es/API/index.php/Usuarios/nombresusuariosCliente/${codcliente}` )
    .map(resp=>{
      if(resp["err"]==false){
        this.listaUsuarios=resp["usuarios"];
        
        return true;
      }else{
        
        return false;
      }
    });
  }

  getNombresUsuariosClientePymes(codcliente){
    return this.http.get( `https://app.solucionlegal.es/API/index.php/Usuarios/nombresusuariosClientePymes/${codcliente}` )
    .map(resp=>{
      if(resp["err"]==false){
        this.listaUsuarios=resp["usuarios"];
        
        return true;
      }else{
        
        return false;
      }
    });
  }

  getNombresUsuariosInterviniente(codInterviniente){
    return this.http.get( `https://app.solucionlegal.es/API/index.php/Usuarios/nombresusuariosInterviniente/${codInterviniente}` )
    .map(resp=>{
      if(resp["err"]==false){
        this.listaUsuarios=resp["usuarios"];
        
        return true;
      }else{
        
        return false;
      }
    });
  }

  getUsuario(codUsuario){
    return this.http.get(`https://app.solucionlegal.es/API/index.php/Usuarios/usuario/${codUsuario}`)
    .map(resp=>{
      return resp;
    });
  }

  actualizarEstado(codUsuario){
    return this.http.get(`https://app.solucionlegal.es/API/index.php/usuarios/actualizarEstado/${codUsuario}`)
    .map(resp=>{
      return resp;
    });
  }

  insertUsuario(usuario){
    let body=JSON.stringify(usuario);
    return this.http.post(`https://app.solucionlegal.es/API/index.php/usuarios/createUsuario`, body)
    .map(resp=>{
      return resp;
    });
  }

  updateUsuario(usuario){
    let body=JSON.stringify(usuario);
    return this.http.post(`https://app.solucionlegal.es/API/index.php/usuarios/updateUsuario`, body)
    .map(resp=>{
      return resp;
    });
  }

  getPerfilesUsuario(){
    return this.http.get(`https://app.solucionlegal.es/API/index.php/usuarios/perfilesUsuario`)
    .map(resp=>{
      this.listaPerfilesUsuario=resp["perfiles"];
      return resp;
    });
  }

  cambiarPass(usuario){
    let body=JSON.stringify(usuario);
    return this.http.post(`https://app.solucionlegal.es/API/index.php/usuarios/cambiarPass`, body)
    .map(resp=>{
      return resp;
    });
  }

  borrarUsuario(codUsuario){
    return this.http.delete(`https://app.solucionlegal.es/API/index.php/usuarios/usuario/${codUsuario}`)
    .map(resp=>{
      return resp;
    })
  }


  
}



// WEBPACK FOOTER //
// ./src/app/services/usuarios.service.ts